import { FunctionComponent } from "react";
import { Input } from "antd";
import { ConfigProvider } from "@ui-kit/ConfigProvider";
import "./OtpInput.css";

const OtpInput: FunctionComponent<OtpInputProps> = ({
  disabled,
  testID,
  accessibilityLabel,
  onChange,
  hint,
  length,
  size = "large",
}) => {
  return (
    <ConfigProvider type="regular">
      <div className={`otp-input-container otp-input-container-${size}`}>
        <Input.OTP
          length={length}
          disabled={disabled}
          aria-label={accessibilityLabel}
          data-testid={testID}
          onChange={onChange}
          inputMode="numeric"
        />
      </div>
      {hint !== undefined && <span className="form-item-hint">{hint}</span>}
    </ConfigProvider>
  );
};

export interface OtpInputProps {
  /**
   * Number of characters in the OTP input
   */
  length: number;
  /**
   * Disable editing of the input
   */
  disabled?: boolean;
  /**
   * Test ID for selection in automated testing, sets `data-testid` attribute
   */
  testID?: string;
  /**
   * Sets `aria-label` for accessability
   */
  accessibilityLabel: string;
  /**
   * Automatically passed in via Form.Item being the direct parent element.
   */
  onChange?: (event: any) => void;
  /*
   * Help text to display below the input.
   */
  hint?: string;
  /**
   * Size of the OTP input
   */
  size?: "small" | "medium" | "large";
}

export { OtpInput };
